export const required = (value) => {
    if (typeof value === 'boolean') {
        return value;
    }
    return String(value).length > 0;
};
